import api from './api';

class CatalogoDigitalService {

    getNombresFotos(denominacion, clase, regla) {
        return api.get(`/api/catalogo_digital/fotos`, {
            params: {
                denominacion: denominacion,
                clase: clase,
                regla: regla
            }
        });
    }

    getNombresFotosAnt(denominacion, clase, regla) {
        const encodedClase = encodeURIComponent(clase);  // Codifica el parámetro 'clase'
        return api.get(`/api/catalogo_digital/fotos/${denominacion}/${encodedClase}/${regla}`);
    }

    consultar(params) {
        return api.post(`/api/catalogo_digital/consultar`, params)
    }
    
    getEnlacesAnexos() {
        return api.get(`/api/enlaces-anexos`)
    }

    getArchivo(idTemp) {
        return api.get(`/api/catalogo_digital/descargar/${idTemp}`, { responseType: 'blob' });
    }

}

export default new CatalogoDigitalService();

